// extracted by mini-css-extract-plugin
module.exports = {"container":"RetailerList_container__FE6vm","retailerslist":"RetailerList_retailerslist__O_yt_","title":"RetailerList_title__e66J_","divider":"RetailerList_divider__xpd1W"};